import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { itemsToCsv } from './batchImport';

export type ExportFormat = 'json' | 'csv';

export async function exportQuestions(subjectId: string, topic: string, format: ExportFormat) {
  const col  = collection(db, 'questions', subjectId, 'topics', topic, 'items');
  const snap = await getDocs(col);
  const items = snap.docs.map(d => ({ _id: d.id, ...d.data() }));

  if (format === 'json') {
    const blob = new Blob([JSON.stringify(items, null, 2)], { type: 'application/json' });
    triggerDownload(blob, `${subjectId}_${topic}.json`);
  } else {
    // 含圖片、音訊、閱讀文章、年份、題號、單元欄位（與批次匯入相同格式）
    const blob = new Blob([itemsToCsv(items)], { type: 'text/csv;charset=utf-8' });
    triggerDownload(blob, `${subjectId}_${topic}.csv`);
  }
}

function triggerDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a   = document.createElement('a');
  a.href    = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
